// src/pages/pengamatan/buah-alami/hooks/useBuahAlamiData.js
import { useState, useEffect } from "react";
import { database } from "../../../../firebase";
import { ref, onValue, off, update } from "firebase/database";

const useBuahAlamiData = (user, userProfile) => {
    const [pendingOrders, setPendingOrders] = useState([]);
    const [processedOrders, setProcessedOrders] = useState([]);
    const [approvedOrders, setApprovedOrders] = useState([]);
    const [closingOrders, setClosingOrders] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
    const [userJabatan, setUserJabatan] = useState(null);
    const [userRoleNames, setUserRoleNames] = useState([]);

// Di useBuahAlamiData.js - PERBAIKI BAGIAN updateStatusPengamatan
const updateStatusPengamatan = async (selectedItems, actionInfo) => {
  try {
    const updates = {};
    
    const { action: newStatus, contextTab } = actionInfo;
    
    // GABUNGKAN SEMUA ORDER DARI SEMUA TAB
    const allOrders = [
      ...pendingOrders,
      ...approvedOrders, 
      ...processedOrders,
      ...closingOrders
    ];
    
    // Kumpulkan semua pengamatanKey unik dari selectedItems
        const uniquePengamatanKeys = [...new Set(
          selectedItems.map(itemId => {
            // CARI ORDER BERDASARKAN itemId
            const order = allOrders.find(o => o.id === itemId);
            if (order) {
              console.log(`Found order for ${itemId}:`, order.pengamatanKey);
              return order.pengamatanKey;
            } else {
              console.log(`No order found for ${itemId}, using fallback`);
              return itemId.split('-')[0];
            }
          })
        )];

    console.log('Unique Pengamatan Keys:', uniquePengamatanKeys);

    let totalPlotsUpdated = 0;

    // Tentukan plot mana yang akan diupdate berdasarkan status baru dan konteks tab
        uniquePengamatanKeys.forEach(pengamatanKey => {
          // CARI ORDER DI SEMUA DATA
          const order = allOrders.find(order => order.pengamatanKey === pengamatanKey);
          
          console.log(`Order found for ${pengamatanKey}:`, order);
          
          if (order && order.allPlots) {
            let plotsToUpdate = [];
            
            // LOGIKA YANG DIPERBAIKI UNTUK PROCESSED
            if (newStatus === 'Processed' && contextTab === 'Approved') {
              // Approved → Processed (di tab Approved)
              plotsToUpdate = order.allPlots.filter(plot => {
                const isApproved = plot.status_pengamatan === 'Approved';
                console.log(`Plot ${plot.plot}: status=${plot.status_pengamatan}, willUpdate=${isApproved}`);
                return isApproved;
              });
              console.log(`Changing Approved → Processed for ${pengamatanKey}, found: ${plotsToUpdate.length} plots`);
            } 
            // TAMBAHKAN LOGIKA LAIN JIKA PERLU
            else if (newStatus === 'Draft' && contextTab === 'Approved') {
              // Approved → Draft (di tab Approved)
              plotsToUpdate = order.allPlots.filter(plot => {
                const isApproved = plot.status_pengamatan === 'Approved';
                return isApproved;
              });
            }
            else if (newStatus === 'Draft' && contextTab === 'Processed') {
              // Processed → Draft (di tab Processed)
              plotsToUpdate = order.allPlots.filter(plot => {
                const isProcessed = plot.status_pengamatan === 'Processed';
                return isProcessed;
              });
            }
            
            console.log(`Plots to update for ${pengamatanKey}:`, plotsToUpdate);
            
            // PERBAIKI PATH: Pastikan path Firebase benar
            plotsToUpdate.forEach(plot => {
              const plotKey = plot.plotKey || plot.plot;
              
              // PATH YANG BENAR untuk status_pengamatan_per_plot
              const path = `db_freshpine/db_pengamatan/buah_alami/${pengamatanKey}/plot/${plotKey}/status_pengamatan_per_plot`;
              
              updates[path] = newStatus;
              totalPlotsUpdated++;
              
              console.log(`Will update: ${path} to ${newStatus}`);
            });
          } else {
            console.log(`No order or allPlots found for ${pengamatanKey}`);
          }
        });
    
    console.log('Total updates to execute:', Object.keys(updates).length);
    console.log('Updates object:', updates);
    
        // Cek jika tidak ada plot yang bisa diupdate
        if (Object.keys(updates).length === 0) {
          console.log('No eligible plots found for update');
          setSnackbar({
            open: true,
            message: "Tidak ada plot yang memenuhi kriteria untuk diubah statusnya. Pastikan plot memiliki status 'Approved'.",
            severity: "warning"
          });
          return {
            success: false,
            updatedCount: 0,
            reason: 'No eligible plots found for update'
          };
        }
    
        // Eksekusi update batch
        console.log('Executing Firebase updates...');
        await update(ref(database), updates);
    
        console.log(`Successfully updated ${totalPlotsUpdated} plots`);
        
        setSnackbar({
          open: true,
          message: `Berhasil mengubah status ${totalPlotsUpdated} plot menjadi ${newStatus}`,
          severity: "success"
        });
    
        return {
          success: true,
          updatedCount: totalPlotsUpdated
        };
    
      } catch (error) {
        console.error("Error updating status:", error);
        console.error("Error details:", {
          message: error.message,
          code: error.code,
          stack: error.stack
        });
        
        setSnackbar({
          open: true,
          message: "Gagal mengubah status: " + error.message,
          severity: "error"
        });
        
        return {
          success: false,
          updatedCount: 0,
          error: error.message
        };
      }
    };

    // Fungsi untuk mengubah format tanggal DD-MM-YYYY menjadi YYYYMMDD untuk sorting
    const formatDateForSorting = (dateString) => {
        if (!dateString || dateString === '-') return '00000000';
        
        try {
            const [day, month, year] = dateString.split('-');
            if (day && month && year) {
                return `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}`;
            }
            return '00000000';
        } catch (error) {
            return '00000000';
        }
    };

    // Fungsi untuk menghitung total populasi dan tanaman
    const calculateTotals = (plotData) => {
        const dataEntry = plotData.data_entry || {};
        const tanaman = dataEntry.tanaman || {};
        const tanamanPinggiran = dataEntry.tanaman_pinggiran || {};
        const populasi = dataEntry.populasi || {};
        
        // Total tanaman normal + kerdil
        const totalTanaman = (parseInt(tanaman.normal_t_ba) || 0) + (parseInt(tanaman.kerdil_t_ba) || 0);
        
        // Total tanaman pinggiran
        const totalTanamanPinggiran = (parseInt(tanamanPinggiran.normal_tp_ba) || 0) + 
                                    (parseInt(tanamanPinggiran.kerdil_tp_ba) || 0) +
                                    (parseInt(tanamanPinggiran.mati_tp_ba) || 0);
        
        // Total populasi
        const totalPopulasi = parseFloat(populasi.total_p_ba) || 0;
        const normalPopulasi = parseFloat(populasi.normal_p_ba) || 0;
        
        return {
            total_tanaman: totalTanaman,
            total_tanaman_pinggiran: totalTanamanPinggiran,
            total_populasi: totalPopulasi,
            normal_populasi: normalPopulasi
        };
    };

    // FUNGSI BARU: Mengelompokkan data berdasarkan id_lokasi dan tanggal_pengamatan
const groupDataByLocationAndDate = (data) => {
    const groupedData = {};
    
    data.forEach(item => {
        const key = `${item.id_lokasi}-${item.tanggal_pengamatan}`;
        
        if (!groupedData[key]) {
            groupedData[key] = {
                id: key,
                pengamatanKey: item.pengamatanKey,
                tanggal_pengamatan: item.tanggal_pengamatan,
                tanggal_pengamatan_sort: item.tanggal_pengamatan_sort,
                lokasi: item.lokasi,
                id_lokasi: item.id_lokasi,
                fmp: item.fmp,
                nama_mandor: item.nama_mandor,
                nama_pengamat: item.nama_pengamat,
                status_pengamatan: item.status_pengamatan,
                plots: [item], // plots yang sudah difilter
                allPlots: [item], // SEMUA plot tanpa filter
                jumlah_plot: 1
            };
        } else {
            groupedData[key].plots.push(item);
            groupedData[key].allPlots.push(item); // Tambah ke allPlots juga
            groupedData[key].jumlah_plot += 1;
            
            // Jika ada perbedaan mandor atau pengamat, gabungkan dengan koma
            if (groupedData[key].nama_mandor !== item.nama_mandor) {
                if (!groupedData[key].nama_mandor.includes(item.nama_mandor)) {
                    groupedData[key].nama_mandor += `, ${item.nama_mandor}`;
                }
            }
            
            if (groupedData[key].nama_pengamat !== item.nama_pengamat) {
                if (!groupedData[key].nama_pengamat.includes(item.nama_pengamat)) {
                    groupedData[key].nama_pengamat += `, ${item.nama_pengamat}`;
                }
            }
        }
    });

    return Object.values(groupedData);
};

    // FUNGSI BARU: Memeriksa status plantation untuk setiap lokasi
    const checkPlantationStatus = async (allPlotData) => {
        const lokasiStatusMap = {};
        
        // Ambil semua id_lokasi unik
        const uniqueLokasiIds = [...new Set(allPlotData.map(item => item.id_lokasi))];
        
        try {
            const lokasiRef = ref(database, `db_freshpine/tb_lokasi`);
            const lokasiSnapshot = await new Promise((resolve) => {
                onValue(lokasiRef, resolve, { onlyOnce: true });
            });

            lokasiSnapshot.forEach((childSnapshot) => {
                const lokasiItem = childSnapshot.val();
                if (uniqueLokasiIds.includes(lokasiItem.id_lokasi)) {
                    lokasiStatusMap[lokasiItem.id_lokasi] = lokasiItem.status_plantation;
                }
            });
        } catch (error) {
            console.error('Error checking plantation status:', error);
        }

        return lokasiStatusMap;
    };

    // FUNGSI BARU: Memisahkan data berdasarkan status plot dan status plantation
const separateDataByStatus = (allPlotData, lokasiStatusMap) => {
    const pendingData = [];
    const approvedData = [];
    const processedData = [];
    const closingData = [];

    // Kelompokkan data terlebih dahulu berdasarkan id_lokasi dan tanggal
    const groupedData = groupDataByLocationAndDate(allPlotData);

    groupedData.forEach(group => {
        const plantationStatus = lokasiStatusMap[group.id_lokasi];
        
        // Jika status plantation tidak active, masukkan ke tab Closing
        if (plantationStatus !== 'active') {
            closingData.push({
                ...group,
                status_pengamatan: 'Closing'
            });
            return;
        }

        // Pisahkan berdasarkan status plot
        const hasPending = group.plots.some(plot => plot.status_pengamatan === 'Pending');
        const hasApproved = group.plots.some(plot => plot.status_pengamatan === 'Approved');
        const hasProcessed = group.plots.some(plot => plot.status_pengamatan === 'Processed');

        // Jika ada plot dengan status Pending, masukkan ke tab Pending
        if (hasPending) {
            const pendingPlots = group.plots.filter(plot => plot.status_pengamatan === 'Pending');
            pendingData.push({
                ...group,
                plots: pendingPlots,
                jumlah_plot: pendingPlots.length,
                status_pengamatan: 'Pending'
            });
        }

        // Jika ada plot dengan status Approved, masukkan ke tab Approved
        if (hasApproved) {
            const approvedPlots = group.plots.filter(plot => plot.status_pengamatan === 'Approved');
            approvedData.push({
                ...group,
                plots: approvedPlots,
                jumlah_plot: approvedPlots.length,
                status_pengamatan: 'Approved'
            });
        }

        // Jika ada plot dengan status Processed, masukkan ke tab Processed
        if (hasProcessed) {
            const processedPlots = group.plots.filter(plot => plot.status_pengamatan === 'Processed');
            processedData.push({
                ...group,
                plots: processedPlots,
                jumlah_plot: processedPlots.length,
                status_pengamatan: 'Processed'
            });
        }
    });

    // Sorting data untuk setiap tab - TERBARU DI ATAS
    const sortDataDescending = (data) => {
        return data.sort((a, b) => {
            const dateCompare = b.tanggal_pengamatan_sort.localeCompare(a.tanggal_pengamatan_sort); // Descending
            if (dateCompare !== 0) return dateCompare;
            
            const lokasiCompare = a.lokasi.localeCompare(b.lokasi);
            if (lokasiCompare !== 0) return lokasiCompare;
            
            return a.id.localeCompare(b.id);
        });
    };

    return {
        pending: sortDataDescending(pendingData),
        approved: sortDataDescending(approvedData),
        processed: sortDataDescending(processedData),
        closing: sortDataDescending(closingData)
    };
};

    useEffect(() => {
        if (!user || !userProfile) {
            setLoadingOrders(true);
            return;
        }

        // Ambil data jabatan user dan role
        const userRef = ref(database, `db_user/tb_user/${user.uid}`);
        
        const unsubscribeUser = onValue(userRef, (userSnapshot) => {
            const userData = userSnapshot.val();

            if (userData) {
                // Ambil data jabatan
                if (userData.id_jabatan) {
                    
                    const jabatanRef = ref(database, `db_config/db_wfms/tb_jabatan/${userData.id_jabatan}`);
                    
                    onValue(jabatanRef, (jabatanSnapshot) => {
                        const jabatanData = jabatanSnapshot.val();
                        
                        if (jabatanData) {
                            setUserJabatan(jabatanData.nama_jabatan);
                        }
                    }, (error) => {
                        console.error('Error fetching jabatan data:', error);
                    });
                }

                // Ambil data role
                if (userData.id_role) {
                    
                    const roleIds = userData.id_role.split(';');
                    
                    const rolePromises = roleIds.map(roleId => {
                        const roleRef = ref(database, `db_config/db_wfms/tb_role/${roleId}`);
                        return new Promise((resolve) => {
                            onValue(roleRef, (roleSnapshot) => {
                                const roleData = roleSnapshot.val();
                                resolve(roleData ? roleData.nama_role : null);
                            }, { onlyOnce: true });
                        });
                    });
                    
                    Promise.all(rolePromises).then(roleNames => {
                        const filteredRoleNames = roleNames.filter(name => name !== null);
                        setUserRoleNames(filteredRoleNames);
                    });
                }
            }
        }, (error) => {
            console.error('Error fetching user data:', error);
        });

        const buahAlamiRef = ref(database, 'db_freshpine/db_pengamatan/buah_alami');
        
        const unsubscribeBuahAlami = onValue(buahAlamiRef, async (snapshot) => {
            const allPlotData = []; // Untuk menyimpan semua data plot
            
            // Process buah alami data sesuai struktur database
            snapshot.forEach((childSnapshot) => {
                const parentData = childSnapshot.val();
                const pengamatanKey = childSnapshot.key;
                
                // Iterasi melalui setiap plot
                if (parentData.plot) {
                    Object.keys(parentData.plot).forEach(plotKey => {
                        const plotData = parentData.plot[plotKey];
                        
                        // Ambil semua data plot tanpa filter status
                        if (plotData.status_pengamatan_per_plot === "Ongoing" ||
                            plotData.status_pengamatan_per_plot === "Draft" ||
                            plotData.status_pengamatan_per_plot === "Pending" || 
                            plotData.status_pengamatan_per_plot === "Approved" ||
                            plotData.status_pengamatan_per_plot === "Rejected" ||  
                            plotData.status_pengamatan_per_plot === "Processed") {
                            
                            // Hitung totals
                            const totals = calculateTotals(plotData);
                            
                            // Buat data plot individual
                            const plotItem = {
                                id: `${pengamatanKey}-${plotKey}`,
                                pengamatanKey: pengamatanKey,
                                plotKey: plotKey,
                                status_pengamatan: plotData.status_pengamatan_per_plot || '-',
                                tanggal_pengamatan: parentData.tanggal_pengamatan || '-',
                                tanggal_pengamatan_sort: formatDateForSorting(parentData.tanggal_pengamatan),
                                lokasi: parentData.lokasi || '-',
                                nama_mandor: parentData.nama_mandor || '-',
                                nama_pengamat: parentData.nama_pengamat || '-',
                                id_lokasi: parentData.id_lokasi || '-',
                                fmp: parentData.fmp || '-',
                                plot: plotData.plot || '-',
                                luas_plot: plotData.luas_plot || '-',
                                pjp: plotData.pjp || '-',
                                
                                // Data dari data_entry
                                buah_alami_ba: plotData.data_entry?.buah_alami_ba || '-',
                                mati_ba: plotData.data_entry?.mati_ba || '-',
                                spot_mati_ba: plotData.data_entry?.spot_mati_ba || '-',
                                total_ba: plotData.data_entry?.total_ba || '-',
                                
                                // Data tanaman
                                normal_t_ba: plotData.data_entry?.tanaman?.normal_t_ba || '-',
                                kerdil_t_ba: plotData.data_entry?.tanaman?.kerdil_t_ba || '-',
                                
                                // Data tanaman pinggiran
                                buah_alami_tp_ba: plotData.data_entry?.tanaman_pinggiran?.buah_alami_tp_ba || '-',
                                normal_tp_ba: plotData.data_entry?.tanaman_pinggiran?.normal_tp_ba || '-',
                                kerdil_tp_ba: plotData.data_entry?.tanaman_pinggiran?.kerdil_tp_ba || '-',
                                mati_tp_ba: plotData.data_entry?.tanaman_pinggiran?.mati_tp_ba || '-',
                                total_tp_ba: plotData.data_entry?.tanaman_pinggiran?.total_tp_ba || '-',
                                
                                // Data populasi
                                normal_p_ba: plotData.data_entry?.populasi?.normal_p_ba || '-',
                                total_p_ba: plotData.data_entry?.populasi?.total_p_ba || '-',
                                
                                // Data fase bunga
                                dry_petals_fb_ba: plotData.data_entry?.fase_bunga?.dry_petals_fb_ba || '-',
                                early_cones_fb_ba: plotData.data_entry?.fase_bunga?.early_cones_fb_ba || '-',
                                early_petals_fb_ba: plotData.data_entry?.fase_bunga?.early_petals_fb_ba || '-',
                                filling_stage_1_fb_ba: plotData.data_entry?.fase_bunga?.filling_stage_1_fb_ba || '-',
                                filling_stage_2_fb_ba: plotData.data_entry?.fase_bunga?.filling_stage_2_fb_ba || '-',
                                late_cones_fb_ba: plotData.data_entry?.fase_bunga?.late_cones_fb_ba || '-',
                                late_petals_fb_ba: plotData.data_entry?.fase_bunga?.late_petals_fb_ba || '-',
                                mid_cones_fb_ba: plotData.data_entry?.fase_bunga?.mid_cones_fb_ba || '-',
                                mid_petals_fb_ba: plotData.data_entry?.fase_bunga?.mid_petals_fb_ba || '-',
                                open_heart_fb_ba: plotData.data_entry?.fase_bunga?.open_heart_fb_ba || '-',
                                red_bud_125_fb_ba: plotData.data_entry?.fase_bunga?.red_bud_125_fb_ba || '-',
                                red_bud_254_fb_ba: plotData.data_entry?.fase_bunga?.red_bud_254_fb_ba || '-',
                                sc0_fb_ba: plotData.data_entry?.fase_bunga?.sc0_fb_ba || '-',
                                sc0_ld_fb_ba: plotData.data_entry?.fase_bunga?.sc0_ld_fb_ba || '-',
                                terpetik_fb_ba: plotData.data_entry?.fase_bunga?.terpetik_fb_ba || '-',
                                
                                // Calculated totals
                                total_tanaman: totals.total_tanaman.toString(),
                                total_tanaman_pinggiran: totals.total_tanaman_pinggiran.toString(),
                                total_populasi: totals.total_populasi.toString(),
                                normal_populasi: totals.normal_populasi.toString()
                            };

                            allPlotData.push(plotItem);
                        }
                    });
                }
            });

            // Check status plantation untuk semua lokasi
            const lokasiStatusMap = await checkPlantationStatus(allPlotData);

            // Pisahkan data berdasarkan status plot dan status plantation
            const separatedData = separateDataByStatus(allPlotData, lokasiStatusMap);

            // Sorting data untuk setiap tab
            const sortData = (data) => {
                return data.sort((a, b) => {
                    const dateCompare = a.tanggal_pengamatan_sort.localeCompare(b.tanggal_pengamatan_sort);
                    if (dateCompare !== 0) return dateCompare;
                    
                    const lokasiCompare = a.lokasi.localeCompare(b.lokasi);
                    if (lokasiCompare !== 0) return lokasiCompare;
                    
                    return a.id.localeCompare(b.id);
                });
            };

            setPendingOrders(sortData(separatedData.pending));
            setApprovedOrders(sortData(separatedData.approved));
            setProcessedOrders(sortData(separatedData.processed));
            setClosingOrders(sortData(separatedData.closing));
            setLoadingOrders(false);
            
        }, (error) => {
            console.error("Error fetching buah alami data:", error);
            setLoadingOrders(false);
            setSnackbar({
                open: true,
                message: "Gagal memuat data buah alami",
                severity: "error"
            });
        });
        
        return () => {
            off(userRef);
            off(buahAlamiRef, 'value');
        };
    }, [user, userProfile]);

    return { 
        orders: [...approvedOrders, ...processedOrders],
        pendingOrders,
        approvedOrders,
        processedOrders,
        closingOrders,
        loadingOrders,
        snackbar,
        setSnackbar,
        userJabatan,
        userRoleNames,
        updateStatusPengamatan 
    };
};

export default useBuahAlamiData;